import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import { getHistoryInstance } from 'hooks/useHistory'

import UAParser from 'ua-parser-js'

const userAgentParser = new UAParser()
const VALID_BROWSERS = ['Chrome', 'Firefox', 'Safari', 'Edge', 'IE']
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN
const SENTRY_ENV = process.env.REACT_APP_ENV || 'dev'
const SENTRY_RELEASE = process.env.REACT_APP_RELEASE || ''

Sentry.init({
  dsn: SENTRY_DSN,
  environment: SENTRY_ENV,
  release: SENTRY_RELEASE,
  integrations: [
    new Integrations.BrowserTracing({
      tracePropagationTargets: ['almanac.io/v1', '*.myalmanac.link/v1'],
      routingInstrumentation: Sentry.reactRouterV5Instrumentation(getHistoryInstance()),
      _metricOptions: {
        _reportAllChanges: true,
      },
    }),
  ],
  ignoreErrors: ['TypeError: Failed to fetch'],
  tracesSampler: (samplingContext) => {
    if (SENTRY_ENV === 'review') return 1.0

    const browser = userAgentParser.getBrowser().name

    if (samplingContext.transactionContext.name === 'V1::UsersController#myself') return 0
    if (samplingContext.transactionContext.name === 'editor-disconnected') return 1.0
    if (typeof samplingContext.transactionContext.metadata?.sampleRate === 'number') {
      return samplingContext.transactionContext.metadata?.sampleRate
    }
    if (browser === undefined) return 0
    if (VALID_BROWSERS.includes(browser)) return 0.6

    return 0
  },
})
